function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import MobileTabNavPlainButton from "segments/desktop/core-components/mobile-tabs/mobile-tab-nav-plain-button";
import { trackEvent } from "services/bigbrain-service";
import { DEMO_ASSET_CLICKED, DEMO_ASSET_LEFT_SIDE_CLICKED, DEMO_STEP_CLICKED } from "constants/bigbrain-event-types";
import { StyledMondayDemoTabsMobileComponent } from "./monday-demo-tabs-mobile-component.scss";
import MondayDemoTabsAsset from "../monday-demo-tab-asset/monday-demo-tabs-asset";
import MondayDemoMobileTimeline from "../monday-demo-mobile-timeline/monday-demo-mobile-timeline";
const MondayDemoTabsMobileComponent = (props)=>{
    const { tabs } = props;
    const [selectedTab, setSelectedTab] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const [wasComponentEverVisible, setWasComponentEverVisible] = useState(false);
    const [videoDurations, setVideoDurations] = useState([]);
    const itemsRef = useRef([]);
    const { theme } = props;
    const VISIBILITY_SENSOR_OFFSET = -200;
    const tabsWithVideoPlayerRefs = [];
    tabs.forEach((tab)=>{
        tabsWithVideoPlayerRefs.push(_object_spread_props(_object_spread({}, tab), {
            videoPlayerRef: useRef(null)
        }));
    });
    useEffect(()=>{
        var _currentTab_videoPlayerRef, _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef_current, _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef, _tabsWithVideoPlayerRefs_selectedTab_asset_video, _tabsWithVideoPlayerRefs_selectedTab_asset, _tabsWithVideoPlayerRefs_selectedTab;
        const currentTab = tabsWithVideoPlayerRefs[selectedTab];
        if (currentTab === null || currentTab === void 0 ? void 0 : (_currentTab_videoPlayerRef = currentTab.videoPlayerRef) === null || _currentTab_videoPlayerRef === void 0 ? void 0 : _currentTab_videoPlayerRef.current) {
            currentTab.videoPlayerRef.current.seekTo(0);
        }
        tabsWithVideoPlayerRefs === null || tabsWithVideoPlayerRefs === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab = tabsWithVideoPlayerRefs[selectedTab]) === null || _tabsWithVideoPlayerRefs_selectedTab === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab_asset = _tabsWithVideoPlayerRefs_selectedTab.asset) === null || _tabsWithVideoPlayerRefs_selectedTab_asset === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab_asset_video = _tabsWithVideoPlayerRefs_selectedTab_asset.video) === null || _tabsWithVideoPlayerRefs_selectedTab_asset_video === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef = _tabsWithVideoPlayerRefs_selectedTab_asset_video.videoPlayerRef) === null || _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef_current = _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef.current) === null || _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef_current === void 0 ? void 0 : _tabsWithVideoPlayerRefs_selectedTab_asset_video_videoPlayerRef_current.seekTo(0);
    }, [
        selectedTab
    ]);
    const scrollToNavigationTabIfVisible = (index)=>{
        if (isVisible) {
            var _itemsRef_current_index, _itemsRef_current;
            itemsRef === null || itemsRef === void 0 ? void 0 : (_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : (_itemsRef_current_index = _itemsRef_current[index]) === null || _itemsRef_current_index === void 0 ? void 0 : _itemsRef_current_index.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    };
    const onTabNavButtonClick = ({ tab, index })=>{
        trackEvent(DEMO_STEP_CLICKED, {
            kind: tab.tabLabel,
            info1: index
        });
        scrollToNavigationTabIfVisible(index);
        setSelectedTab(index);
    };
    const navigationItemRenderer = (tab, index)=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "tab-nav-button-wrapper",
            ref: (element)=>itemsRef.current[index] = element,
            onClick: ()=>onTabNavButtonClick({
                    tab,
                    index
                }),
            children: /*#__PURE__*/ _jsx(MobileTabNavPlainButton, {
                tabNumber: index + 1,
                label: tab.tabLabel,
                selected: selectedTab === index,
                theme: theme
            })
        }, index);
    };
    const onVideoEnded = (index)=>{
        if (index < tabsWithVideoPlayerRefs.length - 1) {
            const nextTabIndex = index + 1;
            setSelectedTab(nextTabIndex);
            scrollToNavigationTabIfVisible(nextTabIndex);
        }
    };
    const setVideoDuration = (index, duration)=>{
        if (videoDurations[index] !== duration) {
            const newVideoDurations = [
                ...videoDurations
            ];
            newVideoDurations[index] = duration;
            setVideoDurations(newVideoDurations);
        }
    };
    const onVisibilityChange = (isVisibleValue)=>{
        if (!wasComponentEverVisible && isVisibleValue) {
            setWasComponentEverVisible(true);
        }
        setIsVisible(isVisibleValue);
    };
    const onAssetClick = ()=>{
        var _tabsWithVideoPlayerRefs_selectedTab;
        trackEvent(DEMO_ASSET_CLICKED, {
            kind: tabsWithVideoPlayerRefs === null || tabsWithVideoPlayerRefs === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab = tabsWithVideoPlayerRefs[selectedTab]) === null || _tabsWithVideoPlayerRefs_selectedTab === void 0 ? void 0 : _tabsWithVideoPlayerRefs_selectedTab.tabLabel,
            info1: selectedTab
        });
        const nextTabIndex = Math.min(selectedTab + 1, tabsWithVideoPlayerRefs.length - 1);
        setSelectedTab(nextTabIndex);
        scrollToNavigationTabIfVisible(nextTabIndex);
    };
    const onLeftSideAssetClick = (e)=>{
        var _tabsWithVideoPlayerRefs_selectedTab;
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        e === null || e === void 0 ? void 0 : e.preventDefault();
        trackEvent(DEMO_ASSET_LEFT_SIDE_CLICKED, {
            kind: tabsWithVideoPlayerRefs === null || tabsWithVideoPlayerRefs === void 0 ? void 0 : (_tabsWithVideoPlayerRefs_selectedTab = tabsWithVideoPlayerRefs[selectedTab]) === null || _tabsWithVideoPlayerRefs_selectedTab === void 0 ? void 0 : _tabsWithVideoPlayerRefs_selectedTab.tabLabel,
            info1: selectedTab
        });
        const nextTabIndex = Math.max(selectedTab - 1, 0);
        setSelectedTab(nextTabIndex);
        scrollToNavigationTabIfVisible(nextTabIndex);
    };
    const assetItemRenderer = (tab, index)=>{
        const isSelected = index === selectedTab;
        return /*#__PURE__*/ _jsxs("div", {
            className: "monday-demo-tabs-asset-click-wrapper",
            onClick: onAssetClick,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "monday-demo-tabs-asset-back-click-wrapper",
                    onClick: onLeftSideAssetClick
                }),
                /*#__PURE__*/ _jsx(MondayDemoTabsAsset, {
                    selectedTab: selectedTab,
                    index: index,
                    isCurrent: isSelected,
                    asset: tab.asset,
                    onVideoEnded: ()=>onVideoEnded(index),
                    autoPlay: isSelected && isVisible,
                    setVideoDuration: (duration)=>setVideoDuration(index, duration)
                })
            ]
        }, index);
    };
    return /*#__PURE__*/ _jsx(VisibilitySensor, {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ _jsxs(StyledMondayDemoTabsMobileComponent, {
            className: "monday-demo-tabs-mobile-component",
            children: [
                /*#__PURE__*/ _jsx(MondayDemoMobileTimeline, {
                    theme: theme,
                    tabs: tabsWithVideoPlayerRefs,
                    selectedTab: selectedTab,
                    wasComponentEverVisible: wasComponentEverVisible,
                    videoDuration: videoDurations[selectedTab]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "monday-demo-tabs-assets-wrapper",
                    children: tabsWithVideoPlayerRefs.map((tab, index)=>// get videoDurations by order, render everything only when component is visible
                        wasComponentEverVisible && index <= videoDurations.length ? assetItemRenderer(tab, index) : null)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mobile-tabs-navigation",
                    children: tabsWithVideoPlayerRefs.map((tab, index)=>navigationItemRenderer(tab, index))
                })
            ]
        })
    });
};
export default MondayDemoTabsMobileComponent;
